import * as ShowType from 'show-page/constants/show-type';
import Color from 'color';
import DisplayAd from 'show-page/components/display-ad';
import styles from './styles.less';
import TVEProvider from 'common/components/tve-provider';
import VideoMetadata from 'show-page/components/video-metadata';
import VideoPlayer from 'common/components/video-player';
import { get } from 'lodash';
import { observer } from 'mobx-react';


function VideoHero(props) {
    const adKey = get(props, 'video.id', '');
    const showProvider = (props.video && props.video.auth && props.tveProvider);
    const backgroundColor = Color(props.backgroundColor);
    const className = cx(styles.root, props.className, {
        [styles.hasVideo]: props.video,
        [styles.isSticky]: props.sticky
    });
    const style = props.sticky ? {
        backgroundColor: backgroundColor.hexString(),
        bottom: 'auto',
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        width: '100%',
        zIndex: 1000
    } : null;
    return (
        <div
            className={ className }
            style={ style }>
            <div className={ styles.content }>
                <div className={ styles.playerContainer }>
                    <VideoPlayer
                        className={ cx(styles.videoPlayer, props.playerProps.className) }
                        playerProps={ props.playerProps }
                        video={ props.video }
                        cvp={ props.showType !== ShowType.TV_SERIES && !props.useASPlayer }
                        asvp={ props.useASPlayer }
                    />
                    { !!showProvider &&
                    <TVEProvider
                        className={ styles.tveProvider }
                        invert={ backgroundColor.light() }
                        onLogoutClick={ props.onTVERequestLogout }
                        provider={ props.tveProvider }
                    /> }
                </div>
                <div className={ styles.side }>
                    <DisplayAd
                        adID='ad_rect_atf_01'
                        adKey={ adKey }
                        adType={ props.adType }
                        className={ styles.rightAdContainer }
                        dfpProps={{
                            adClassName: styles.ad,
                            className: styles.dfpAd,
                            type: 'rect'
                        }}
                        fwProps={{
                            className: styles.fwAd,
                            height: 250,
                            placement: '300x250_sync',
                            width: 300
                        }}
                    />
                    { !!props.video &&
                    <VideoMetadata
                        { ...props.metadataProps }
                        className={ cx(styles.meta, props.metadataProps.className) }
                        sticky={ props.sticky }
                        video={ props.video }
                    /> }
                </div>
            </div>
        </div>
    );
}

VideoHero.propTypes = {
    adType: React.PropTypes.string,
    backgroundColor: React.PropTypes.string.isRequired,
    metadataProps: React.PropTypes.object,
    onTVERequestLogout: React.PropTypes.func,
    playerProps: React.PropTypes.object,
    showType: React.PropTypes.string.isRequired,
    sticky: React.PropTypes.bool,
    tveProvider: React.PropTypes.object,
    video: React.PropTypes.object
};

VideoHero.defaultProps = {
    backgroundColor: '#111111',
    metadataProps: {},
    playerProps: {},
    sticky: false
};


export default observer(VideoHero);



// WEBPACK FOOTER //
// ./src/show-page/components/video-hero/index.js